export const YesNoSelection = [
  { value: "", label: "Select" },
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];
